import { AllOwnerConfirmComponent } from './../all-owner-confirm/all-owner-confirm.component';
import { AfterViewInit, ElementRef, EventEmitter, Injectable, Input, Output, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter, NgbDateStruct, NgbInputDatepickerConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationOwner, RegistrationRequest, RegistrationStaff } from 'app/model/RegistrationRequest'; // ADD RegistrationStaff import
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { CrmService } from 'app/services/crm.service';
import { stringify } from '@angular/compiler/src/util';
import { ToastService } from 'app/services/toast.service';
import { Suburb } from 'app/model/suburbs';
import { Observable, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { RequestSource } from 'app/model/RequestSource';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { PharmacyOwnerNgbdModalContent } from '../pharmacy-registration-owner/pharmacy-registration-owner.component';
// Add these imports at the top of your pharmacy-registration.component.ts
import { PharmacyStaffNgbdModalContent } from '../pharmacy-staff-modal/pharmacy-staff-modal.component';
import { getLocaleDateTimeFormat } from '@angular/common';



declare var $: any;

@Injectable()
export class DdMmYyyyDateParserFormatter extends NgbDateParserFormatter {
  private twoDigits(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const parts = value.trim().split('/');
    if (parts.length !== 3) {
      return null;
    }

    const day = Number(parts[0]);
    const month = Number(parts[1]);
    const year = Number(parts[2]);
    if (!this.isValidDateStruct({ day, month, year })) {
      return null;
    }

    return { day, month, year };
  }

  format(date: NgbDateStruct | null): string {
    if (!date || !this.isValidDateStruct(date)) {
      return '';
    }

    const day = this.twoDigits(date.day);
    const month = this.twoDigits(date.month);
    return `${day}/${month}/${date.year}`;
  }

  private isValidDateStruct(date: { day: number; month: number; year: number }): boolean {
    if (!date || !date.day || !date.month || !date.year) {
      return false;
    }

    if (date.month < 1 || date.month > 12 || date.day < 1 || date.day > 31 || date.year < 1000) {
      return false;
    }

    const candidate = new Date(date.year, date.month - 1, date.day);
    return candidate.getFullYear() === date.year
      && candidate.getMonth() === date.month - 1
      && candidate.getDate() === date.day;
  }
}

@Component({
  selector: 'app-pharmacy-registration',
  templateUrl: './pharmacy-registration.component.html',
  styleUrls: ['./pharmacy-registration.component.css'],
  providers: [
    {
      provide: NgbDateParserFormatter,
      useClass: DdMmYyyyDateParserFormatter
    }
  ]
})

export class PharmacyRegistrationComponent implements OnInit {
  pbsApprovalDatePickerModel: NgbDateStruct = null;
 formSubmitted = false;
  checkboxError = false;
  postalFormSubmitted = false;
postalAddressRequired = false;
// ADD THESE NEW PROPERTIES:
  selectedRole: string = '';
  staffList: RegistrationStaff[] = []; // CHANGE: Use RegistrationStaff[]
  ownersList: RegistrationOwner[] = [];
  private formEntryOwner: RegistrationOwner = null;
showTooltip1 = false;
  constructor(private modalService: NgbModal, private crmService: CrmService, private toastService: ToastService, private route: ActivatedRoute,
    private router: Router) { }
// Add these properties to your component class
//
// tooltipText = 'AHPRA Number is your registration number with the Australian Health Practitioner Regulation Agency. This is required for all registered healthcare practitioners.';
tooltipText = 'Australian Health Practitioner Regulation Agency Number. This is required for all registered healthcare practitioners. e.g PHA0001612901';

// Add these simple methods
showTooltip(): void {
  this.showTooltip1 = true;
}

hideTooltip(): void {
  this.showTooltip1 = false;
}
  pr: RegistrationRequest;
  suburbs: Suburb[];
  requestSources: RequestSource[];
  isSubmitting = false;
  data = "";
  todayDate: any;
  toMinDate: any;
  differentAddress: boolean = false;
  @ViewChild('f') public f: NgForm;

  @BlockUI() blockUI: NgBlockUI;

ngOnInit(): void {
  this.todayDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };
  window.document.title = "Pharmacy Registration";
  
  // Initialize pr with all required properties
  this.pr = new RegistrationRequest();
  this.pr.registrationOwners = new Array<RegistrationOwner>();
  this.pr.registrationStaff = new Array<RegistrationStaff>(); // THIS LINE IS NOW CORRECT
  
  // Initialize staff and owners lists
  this.staffList = [];  // Make sure this is initialized
  this.ownersList = []; // Make sure this is initialized
  
  // Initialize all checkbox properties
  this.pr.transferofownership = false;
  this.pr.changeofownership = false;
  this.pr.other = false;
  this.pr.detailsOfOther = '';
  this.pr.belongToGroup = false;
  this.pr.readyToBeAssessed = false;
  
  // Initialize PBS properties
  this.pr.hasPBSNumber = '';
  this.pr.pbsApprovalNumber = '';
  this.pr.pbsApprovalDate = null;
  this.pr.pbsApprovalStatus = null;
  
  // FIX: Initialize contact person properties to null (not empty string)
  this.pr.contactPersonIsOwner = null;
  this.pr.contactPersonRole = null; // Change from '' to null
  this.pr.contactPersonOtherRole = null; // Change from '' to null
  
  // Initialize other properties
  this.pr.requestType = undefined;
    /*this.crmService.GetSuburbs().subscribe(x => { this.suburbs = x;this.blockUI.stop(); },
      error => { this.toastService.showDanger("Error retrieving suburbs");this.blockUI.stop(); });*/
    this.crmService.GetRequestSource().subscribe(x => { this.requestSources = x; },
      error => { this.toastService.showDanger("Error retrieving request sources") });
    //this.blockUI.stop(); 
    this.data = this.route.snapshot.queryParams.data;
    if (this.data) {
      let params = window.atob(this.data).split(";");
      this.pr.firstName = params[0];
      this.pr.lastName = params[1];
      this.pr.primaryEmail = params[2];
      this.pr.ahpraNumber = params[3];
      this.pr.mobile = params[4];

      this.pr.contactPreferredName = params[5];
    }

    this.pbsApprovalDatePickerModel = this.parseIsoDate(this.pr.pbsApprovalDate);
  }
// formSubmitted = false; // Track if form has been submitted
// checkboxError = false; // Track checkbox validation state

validateReasonForChange(): boolean {
  if (!this.pr.requestType) return true; // Skip validation if not existing pharmacy
  
  // Check if at least one checkbox is selected
  const isValid = this.pr.transferofownership || 
                 this.pr.changeofownership || 
                 this.pr.other;
  
  this.checkboxError = !isValid;
  return isValid;
}

getPostalAddressErrors(): string[] {
  const errors: string[] = [];
  
  if (this.differentAddress) {
    if (!this.pr.postalAddressStreet1) errors.push("Street 1 is required");
    if (!this.pr.postalSuburb) errors.push("Suburb is required");
    if (!this.pr.postalState) errors.push("State is required");
    if (!this.pr.postalPostCode) errors.push("Post Code is required");
    if (this.pr.postalPostCode && !this.pr.postalPostCode.match(/^[0-9]{4}$/)) {
      errors.push("Post Code must be 4 digits");
    }
  }
  
  return errors;
}
checkMissingRequiredFields(): string[] {
  const errorMessages: string[] = [];

  Object.keys(this.f.controls).forEach(key => {
    const control = this.f.controls[key];

    if (control.invalid && control.errors) {
      errorMessages.push(this.getFieldErrorMessage(key, control.errors));
    }
  });

  return errorMessages;
}

getFieldErrorMessage(fieldName: string, errors: any): string {
  const fieldConfig: {[key: string]: {required?: string, invalid?: string}} = {
    'pharmacyName':        { required: 'Pharmacy Name is required' },
    'abn':                 { required: 'ABN is required', invalid: 'ABN is incorrect' },
    'phone':               { required: 'Pharmacy Phone is required', invalid: 'Pharmacy Phone must be 10 digits' },
    'primaryEmail':        { required: 'Primary Email is required', invalid: 'Primary Email is invalid' },
    'pharmacyAddressStreet1': { required: 'Street Address 1 is required' },
    'pharmacySuburb':      { required: 'Suburb is required' },
    'pharmacyState':       { required: 'State is required' },
    'pharmacyPostCode':    { required: 'Post Code is required' },
    'firstName':           { required: 'First Name is required' },
    'lastName':            { required: 'Last Name is required' },
    'mobile':              { required: 'Mobile is required', invalid: 'Mobile number is incorrect' },
    'hasPBSNumber':        { required: 'PBS Number Status is required' },
    'pbsApprovalNumber':   { required: 'PBS Approval Number is required' },
    'pbsApprovalStatus':   { required: 'PBS Approval Status is required' },
    'readyToBeAssessed':   { required: 'Assessment Readiness is required' },
    'contactPersonRole':   { required: 'Contact Person Role is required' },
    'contactPersonOtherRole': { required: 'Contact Person Other Role is required' },
    'bannerGroupName':     { required: 'Banner Group Name is required' },
    'managmentGroupName':  { required: 'Management Group Name is required' }
  };

  const cfg = fieldConfig[fieldName];

  if (errors.required) {
    return cfg?.required || `${fieldName} is required`;
  }
  if (errors.abnValidator) {
    return cfg?.invalid || 'ABN is incorrect';
  }
  if (errors.pattern || errors.email) {
    return cfg?.invalid || `${fieldName} is incorrect`;
  }
  return cfg?.invalid || `${fieldName} is invalid`;
}
// Add this method to handle role changes
onRoleChange(): void {
  // Reset the other role field if not selecting "Other"
  if (this.pr.contactPersonRole !== '806460002') {
    this.pr.contactPersonOtherRole = '';
  }
}

private normalizeBooleanFields(data: any): any {
  const booleanFields = [
    'contactPersonIsOwner',
    'hasPBSNumber', 
    'readyToBeAssessed',
    'transferofownership',
    'changeofownership',
    'other',
    'belongToGroup'
  ];

  booleanFields.forEach(field => {
    if (data[field] !== undefined && data[field] !== null) {
      if (typeof data[field] === 'string') {
        data[field] = data[field].toLowerCase() === 'true';
      }
    }
  });
  
  return data;
}

  // Open Staff Modal for Adding
openStaffModal(): void {
  if (!this.modalService.hasOpenModals()) {
    const modal = this.modalService.open(PharmacyStaffNgbdModalContent, { 
      size: 'lg',
      backdrop: 'static'
    });
    
    modal.componentInstance.ro = new RegistrationStaff();
    modal.componentInstance.suburbs = this.suburbs;
    
    modal.componentInstance.passEntry.subscribe((staff: RegistrationStaff) => {
      this.staffList.push(staff);
      // Also add to the main registration request
      this.pr.registrationStaff.push(staff);
      console.log('Staff added:', staff);
    });
  }
}

// Add these methods to your pharmacy-registration.component.ts class

// Add Staff Modal methods
editStaff(index: number): void {
  if (!this.modalService.hasOpenModals()) {
    const modal = this.modalService.open(PharmacyStaffNgbdModalContent, { 
      size: 'lg',
      backdrop: 'static'
    });
    
    // Clone the staff object to avoid direct reference
    const staffToEdit = JSON.parse(JSON.stringify(this.staffList[index]));
    modal.componentInstance.ro = staffToEdit;
    modal.componentInstance.suburbs = this.suburbs;
    
    modal.componentInstance.passEntry.subscribe((updatedStaff: RegistrationStaff) => {
      this.staffList[index] = updatedStaff;
      // Also update in the main registration request
      const staffIndex = this.pr.registrationStaff.findIndex(s => 
        s.emailAddress === updatedStaff.emailAddress || 
        (s.firstName === updatedStaff.firstName && s.lastName === updatedStaff.lastName)
      );
      if (staffIndex !== -1) {
        this.pr.registrationStaff[staffIndex] = updatedStaff;
      }
      console.log('Staff updated:', updatedStaff);
    });
  }
}

deleteStaff(index: number): void {
  if (confirm('Are you sure you want to delete this staff member?')) {
    const staffToDelete = this.staffList[index];
    this.staffList.splice(index, 1);
    
    // Also remove from the main registration request
    const staffIndex = this.pr.registrationStaff.findIndex(s => 
      s.emailAddress === staffToDelete.emailAddress || 
      (s.firstName === staffToDelete.firstName && s.lastName === staffToDelete.lastName)
    );
    if (staffIndex !== -1) {
      this.pr.registrationStaff.splice(staffIndex, 1);
    }
    
    console.log('Staff deleted at index:', index);
  }
}

// Add Owner Modal methods (for consistency)
editOwner(index: number): void {
  if (!this.modalService.hasOpenModals()) {
    const modal = this.modalService.open(PharmacyOwnerNgbdModalContent, { 
      size: 'xl',
      backdrop: 'static'
    });
    
    const ownerToEdit = JSON.parse(JSON.stringify(this.ownersList[index]));
    modal.componentInstance.ro = ownerToEdit;
    modal.componentInstance.suburbs = this.suburbs;
    
    modal.componentInstance.passEntry.subscribe((updatedOwner: RegistrationOwner) => {
      this.ownersList[index] = updatedOwner;
      // Also update in the main registration request
      const ownerIndex = this.pr.registrationOwners.findIndex(o => 
        o.emailAddress === updatedOwner.emailAddress || 
        (o.firstName === updatedOwner.firstName && o.lastName === updatedOwner.lastName)
      );
      if (ownerIndex !== -1) {
        this.pr.registrationOwners[ownerIndex] = updatedOwner;
      }
      console.log('Owner updated:', updatedOwner);
    });
  }
}

// deleteOwner(index: number): void {
//   if (confirm('Are you sure you want to delete this owner?')) {
//     const ownerToDelete = this.ownersList[index];
//     this.ownersList.splice(index, 1);
    
//     // Also remove from the main registration request
//     const ownerIndex = this.pr.registrationOwners.findIndex(o => 
//       o.emailAddress === ownerToDelete.emailAddress || 
//       (o.firstName === ownerToDelete.firstName && o.lastName === ownerToDelete.lastName)
//     );
//     if (ownerIndex !== -1) {
//       this.pr.registrationOwners.splice(ownerIndex, 1);
//     }
    
//     console.log('Owner deleted at index:', index);
//   }
// }

// Role change handler
onRoleChangeSelection(): void {
  // Reset lists when role changes
  if (this.selectedRole === 'pharmacyStaff') {
    // Staff-specific initialization if needed
  } else if (this.selectedRole === 'pharmacyOwner') {
    // Owner-specific initialization if needed
  }
}
  // Open Owner Modal for Adding (from role selection)
openOwnerModal(): void {
  if (!this.modalService.hasOpenModals()) {
    const modal = this.modalService.open(PharmacyOwnerNgbdModalContent, { 
      size: 'xl',
      backdrop: 'static'
    });
    
    modal.componentInstance.ro = new RegistrationOwner();
    modal.componentInstance.suburbs = this.suburbs;
    
    modal.componentInstance.passEntry.subscribe((owner: RegistrationOwner) => {
      this.ownersList.push(owner);
      // Also add to the main registration request
      this.pr.registrationOwners.push(owner);
      console.log('Owner added:', owner);
    });
  }
}

onSubmit() {
    this.formSubmitted = true;
    
    // Step 1: Basic form validation
    if (!this.f.valid) {
        const missingFields = this.checkMissingRequiredFields();
        if (missingFields.length > 0) {
            this.toastService.showDanger(missingFields.join('; '));
        } else {
            this.toastService.showDanger("Please complete all required fields");
        }
        return;
    }

    // Step 2: Reason for change validation (existing pharmacy only)
    if (this.pr.requestType && !this.validateReasonForChange()) {
        this.toastService.showDanger("Please select at least one reason for change");
        return;
    }

    // Step 3: Other details validation
    if (this.pr.other && this.pr.requestType && !this.pr.detailsOfOther) {
        this.toastService.showDanger("Details of Other is required");
        return;
    }

    // Step 4: Postal address validation
    const postalErrors = this.getPostalAddressErrors();
    if (postalErrors.length > 0) {
        this.toastService.showDanger(postalErrors.join(', '));
        return;
    }

// Step 5: Contact person role validation - FIXED
if (this.pr.contactPersonIsOwner === false || this.pr.contactPersonIsOwner === 'false') {
    if (!this.pr.contactPersonRole || this.pr.contactPersonRole === '0') {
        this.toastService.showDanger("Please specify the role of this person");
        return;
    }
    
    // if (this.pr.contactPersonRole === '806460002' && !this.pr.contactPersonOtherRole) {
    //     this.toastService.showDanger("Please specify the role");
    //     return;
    // }
} else if (this.pr.contactPersonIsOwner === true || this.pr.contactPersonIsOwner === 'true') {
    // Clear role fields when contact person IS owner
    this.pr.contactPersonRole = null;
    this.pr.contactPersonOtherRole = null;
}

    // Step 6: PBS validation
    if (!this.pr.hasPBSNumber) {
        this.toastService.showDanger("Please specify if the pharmacy has a PBS number");
        return;
    }

    if (this.pr.hasPBSNumber === 'true' && !this.pr.pbsApprovalNumber) {
        this.toastService.showDanger("PBS Approval Number is required when pharmacy has PBS number");
        return;
    }

    if (this.pr.hasPBSNumber === 'false' && !this.pr.pbsApprovalStatus) {
        this.toastService.showDanger("PBS Approval Status is required when pharmacy doesn't have a PBS number");
        return;
    }

    // Step 7: Group validation
    if (this.pr.belongToGroup) {
        if (!this.pr.bannerGroupName) {
            this.toastService.showDanger("Banner Group Name is required");
            return;
        }
        if (!this.pr.managmentGroupName) {
            this.toastService.showDanger("Management Group Name is required");
            return;
        }
    }

    // Step 8: Assessment validation (new pharmacies only)
    // if (this.pr.requestType === false) {
    //     if (!this.pr.readyToBeAssessed) {
    //         this.toastService.showDanger("Please indicate if the pharmacy is ready to be assessed");
    //         return;
    //     }
        
    //     if (this.pr.readyToBeAssessed && (!this.pr.preferredFromDate || !this.pr.preferredToDate)) {
    //         this.toastService.showDanger("Preferred dates are required when pharmacy is ready for assessment");
    //         return;
    //     }
    // }
     if (this.pr.readyToBeAssessed && (!this.pr.preferredFromDate || !this.pr.preferredToDate)) {
            this.toastService.showDanger("Preferred dates are required when pharmacy is ready for assessment");
            return;
        }

    // Step 9: Owner validation (only if contact person is owner)
if (this.pr.contactPersonIsOwner === 'true' || this.pr.contactPersonIsOwner === true) {
  // Ensure the automatic owner is created
  this.ContactOwnerChanged();
  
  // Validate all owners
  for (let i = 0; i < this.pr.registrationOwners.length; i++) {
    let o = this.pr.registrationOwners[i];
    if (!o.firstName || !o.lastName || !o.ahpraNumber || !o.emailAddress) {
      this.toastService.showDanger(`Owner ${i + 1} is missing required information`);
      return;
    }
  }
}

    // Mandatory owner check before submission
    if ((this.pr.registrationOwners || []).length === 0) {
        this.toastService.showDanger('Please add at least one owner before submitting the registration.');
        return;
    }

    // All validations passed - show confirmation dialog
    this.showConfirmationDialog();
}
ContactOwnerChanged(): void {
  // Reset other-role field when not "Owner"
  if (this.pr.contactPersonRole !== 806460002) {
    this.pr.contactPersonOtherRole = null;
  }

  if (this.pr.contactPersonRole === 806460002) {
    // Build a RegistrationOwner from the contact person fields
    const owner = new RegistrationOwner();
    owner.firstName = this.pr.firstName;
    owner.lastName = this.pr.lastName;
    owner.preferredName = this.pr.contactPreferredName;
    owner.mobileNumber = this.pr.mobile;
    owner.emailAddress = this.pr.primaryEmail;

    if (this.formEntryOwner) {
      // Update the existing auto-added row in-place in both arrays
      const idx = this.pr.registrationOwners.indexOf(this.formEntryOwner);
      if (idx !== -1) {
        this.pr.registrationOwners[idx] = owner;
        this.ownersList[idx] = owner;
      }
    } else {
      // First time selecting Owner — push a new row into both arrays
      this.pr.registrationOwners.push(owner);
      this.ownersList.push(owner);
    }
    this.formEntryOwner = owner;
  } else {
    // Role changed away from Owner — remove the auto-added row from both arrays
    if (this.formEntryOwner) {
      const idx = this.pr.registrationOwners.indexOf(this.formEntryOwner);
      if (idx !== -1) {
        this.pr.registrationOwners.splice(idx, 1);
        this.ownersList.splice(idx, 1);
      }
      this.formEntryOwner = null;
    }
  }
}
onContactPersonChange(value: any): void {
    this.pr.contactPersonIsOwner = value;
}


private showConfirmationDialog(): void {
    this.confirmDialog().then(result => {
        if (result === "Yes") {
            this.submitForm();
        }
    });
}

private debugApiData(data: any): void {
  console.log('=== DEBUG API DATA ===');
  console.log('contactPersonIsOwner:', data.contactPersonIsOwner);
  console.log('contactPersonRole:', data.contactPersonRole);
  console.log('contactPersonOtherRole:', data.contactPersonOtherRole);
  
  // Check if role field exists and its value
  console.log('Has contactPersonRole property:', data.hasOwnProperty('contactPersonRole'));
  console.log('contactPersonRole value:', data.contactPersonRole);
  
  // Stringify and parse to see hidden properties
  const stringified = JSON.stringify(data);
  console.log('Full JSON string:', stringified);
  
  const parsed = JSON.parse(stringified);
  console.log('Parsed object contactPersonRole:', parsed.contactPersonRole);
  console.log('=== END DEBUG ===');
}
private submitForm(): void {
  this.isSubmitting = true;
  this.blockUI.start();

  // Create the data object
  // Helper to convert NgbDateStruct or {year, month, day} to yyyy-MM-dd string
  function formatDateStruct(date: any): string | null {
    if (!date || !date.year || !date.month || !date.day) return null;
    const mm = date.month.toString().padStart(2, '0');
    const dd = date.day.toString().padStart(2, '0');
    return `${date.year}-${mm}-${dd}`;
  }

  const apiData: any = {
    pharmacyName: this.pr.pharmacyName,
    abn: this.pr.abn ? this.pr.abn.trim() : this.pr.abn,
    phone: this.pr.phone,
    mobile: this.pr.mobile,
    firstName: this.pr.firstName,
    lastName: this.pr.lastName,
    ahpraNumber: this.pr.ahpraNumber ? this.pr.ahpraNumber.trim() : this.pr.ahpraNumber,
    requestSource: this.pr.requestSource ?? 806390000,
    pharmacyAddressStreet1: this.pr.pharmacyAddressStreet1,
    pharmacyAddressStreet2: this.pr.pharmacyAddressStreet2,
    postalAddressStreet1: this.pr.postalAddressStreet1,
    postalAddressStreet2: this.pr.postalAddressStreet2,
    pharmacySuburb: this.pr.pharmacySuburb,
    pharmacyState: this.pr.pharmacyState,
    pharmacyPostCode: this.pr.pharmacyPostCode,
    postalSuburb: this.pr.postalSuburb,
    postalState: this.pr.postalState,
    postalPostCode: this.pr.postalPostCode,
    primaryEmail: this.pr.primaryEmail,
    invoiceEmail: this.pr.invoiceEmail,
    headOfficeEmail: this.pr.headOfficeEmail,
    pharmacyGuildNumber: this.pr.pharmacyGuildNumber,
    contactPersonIsOwner: this.convertToBoolean(this.pr.contactPersonIsOwner),
    fax: this.pr.fax,
    readyToBeAssessed: this.convertToBoolean(this.pr.readyToBeAssessed),
    preferredFromDate: formatDateStruct(this.pr.preferredFromDate),
    preferredToDate: formatDateStruct(this.pr.preferredToDate),
    registrationOwners: (this.pr.registrationOwners || []).map(owner => ({
      ...owner,
      ahpraNumber: owner && owner.ahpraNumber ? owner.ahpraNumber.trim() : owner.ahpraNumber
    })),
    registrationStaff: (this.pr.registrationStaff || []).map(staff => ({
      ...staff,
      ahpraNumber: staff && staff.ahpraNumber ? staff.ahpraNumber.trim() : staff.ahpraNumber
    })),
    belongToGroup: this.convertToBoolean(this.pr.belongToGroup),
    bannerGroupName: this.pr.bannerGroupName,
    managmentGroupName: this.pr.managmentGroupName,
    pharmacySignage: this.pr.pharmacySignage,
    bulkBuyingSystem: this.pr.bulkBuyingSystem,
    groupBtandedMedicines: this.pr.groupBtandedMedicines,
    groupBrandedUniform: this.pr.groupBrandedUniform,
    groupBrandedMarketing: this.pr.groupBrandedMarketing,
    groupManagementSystems: this.pr.groupManagementSystems,
    qcppid: this.pr.qcppid || null,
    oldpbsnumber: this.pr.oldpbsnumber || null,
    changeofownership: this.pr.changeofownership,
    transferofownership: this.pr.transferofownership,
    other: this.pr.other,
    detailsOfOther: this.pr.detailsOfOther,
    requestType: this.pr.requestType,
    contactPreferredName: this.pr.contactPreferredName,
  contactEmailAddress: this.pr.contactEmailAddress,
    hasPBSNumber: this.convertToBoolean(this.pr.hasPBSNumber),
    contactPersonOtherRole: this.pr.contactPersonOtherRole,
    contactPersonRole: this.pr.contactPersonRole,
    pbsApprovalNumber: this.pr.pbsApprovalNumber,
    pbsApprovalDate: this.pr.pbsApprovalDate,
    pbsApprovalStatus: this.pr.pbsApprovalStatus ? parseInt(this.pr.pbsApprovalStatus.toString(), 10) : null
  };

  // FIX: Always send valid role values instead of letting backend use defaults
  if (apiData.contactPersonIsOwner === true) {
    // When contact person IS owner, set a valid default role
    apiData.contactPersonRole = 806460000; // "Pharmacy staff" as default
    apiData.contactPersonOtherRole = null;
  } else {
    // When contact person is NOT owner, use the selected role
    // if (this.pr.contactPersonRole && this.isValidRoleValue(this.pr.contactPersonRole)) {
    //   apiData.contactPersonRole = parseInt(this.pr.contactPersonRole.toString(), 10);
    //   if (apiData.contactPersonRole === 806460002 && this.pr.contactPersonOtherRole) {
    //     apiData.contactPersonOtherRole = this.pr.contactPersonOtherRole;
    //   } else {
    //     apiData.contactPersonOtherRole = null;
    //   }
    // } else {
    //   // Set default valid role if none selected
    //   apiData.contactPersonRole = 806460000; // "Pharmacy staff"
    //   apiData.contactPersonOtherRole = null;
    // }
  }

  console.log('✅ FINAL API DATA:');
  console.log('contactPersonIsOwner:', apiData.contactPersonIsOwner);
  console.log('contactPersonRole:', apiData.contactPersonRole);
  console.log('contactPersonOtherRole:', apiData.contactPersonOtherRole);
  console.log('Registration Owners count:', apiData.registrationOwners?.length);
  console.log('Registration Staff count:', apiData.registrationStaff?.length);
  console.log('Full Data:', JSON.stringify(apiData, null, 2));

  this.crmService.SubmitRegistrationRequest(apiData).subscribe(
    response => {
      this.toastService.showSuccess('Registration Successful!');
      this.resetForm();
      this.router.navigate(['registration-completed']);
      this.blockUI.stop();
      this.isSubmitting = false;
    },
    error => {
      console.error('❌ REGISTRATION ERROR:');
      console.error('Error details:', error);
      this.toastService.showDanger('Registration failed. Please try again.');
      this.blockUI.stop();
      this.isSubmitting = false;
    }
  );
}

// Add this helper method
private isValidRoleValue(role: any): boolean {
  const validRoles = ['806460000', '806460001', '806460002', 806460000, 806460001, 806460002];
  return validRoles.includes(role);
}
private resetForm(): void {
    this.pr = new RegistrationRequest();
    this.pr.registrationOwners = new Array<RegistrationOwner>();
    this.pr.registrationStaff = new Array<RegistrationStaff>(); // ADD THIS
    this.staffList = []; // Clear staff list
    this.ownersList = []; // Clear owners list
    this.selectedRole = ''; // Reset role selection
    this.formSubmitted = false;
    this.differentAddress = false;
    this.formEntryOwner = null; // Clear auto-added owner tracker

    // Reset contact owner selection to unselected
    this.pr.contactPersonIsOwner = null;

    if (this.f) {
        this.f.resetForm();
    }
}

  confirmDialog(): Promise<any> {
    if (!this.modalService.hasOpenModals()) {
      $('ngb-modal-backdrop').addClass('modal-backdrop fade show');
      $('ngb-modal-window').addClass('d-block modal fade show');
      $('div[role="document"]').addClass('modal-dialog');
      var modal = this.modalService.open(AllOwnerConfirmComponent, { size: 'lg' });
      return modal.result
    }
  }

  search: OperatorFunction<string, readonly Suburb[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.suburbs.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  formatter = (x: any) => x.name + ' - ' + x.state.name + ' - ' + x.postCode.name;

  addressChange = () => {
    if (!this.differentAddress) {
      this.copyAddressChange()
    }
  }


  postalAddressChange = () => {
    if (!this.differentAddress) {
      this.copyAddressChange()
    }
  }

  copyAddressChange(): void {
    if (!this.differentAddress) {
      this.pr.postalAddressStreet1 = this.pr.pharmacyAddressStreet1;
      this.pr.postalAddressStreet2 = this.pr.pharmacyAddressStreet2;
      this.pr.postalSuburb = this.pr.pharmacySuburb;
      this.pr.postalPostCode = this.pr.pharmacyPostCode;
      this.pr.postalState = this.pr.pharmacyState;
    } else {
      this.pr.postalAddressStreet1 = "";
      this.pr.postalAddressStreet2 = "";
      this.pr.postalSuburb = null;
      this.pr.postalPostCode = null;
      this.pr.postalState = "";
    }
  };

private convertToBoolean(value: any): boolean {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true' || value === '1';
  }
  if (typeof value === 'number') return value === 1;
  return false;
}


  open() {
    if (!this.modalService.hasOpenModals()) {
      var modal = this.modalService.open(PharmacyOwnerNgbdModalContent, { size: 'xl' });
      modal.componentInstance.suburbs = this.suburbs;
      modal.componentInstance.passEntry.subscribe((receivedEntry) => {
        this.pr.registrationOwners.push(receivedEntry);
        this.ownersList.push(receivedEntry); // ADD THIS: Update ownersList
      });
      $('ngb-modal-backdrop').addClass('modal-backdrop fade show');
      $('ngb-modal-window').addClass('d-block modal fade show');
      $('div[role="document"]').addClass('modal-dialog');
    }
  }

  viewOwner(registrationOwner) {
    if (!this.modalService.hasOpenModals()) {
      var modal = this.modalService.open(PharmacyOwnerNgbdModalContent, { size: 'xl' });
      modal.componentInstance.suburbs = this.suburbs;
      modal.componentInstance.ro = registrationOwner;
      modal.componentInstance.passEntry.subscribe((receivedEntry) => {
        registrationOwner = receivedEntry;
      });
      $('ngb-modal-backdrop').addClass('modal-backdrop fade show');
      $('ngb-modal-window').addClass('d-block modal fade show');
      $('div[role="document"]').addClass('modal-dialog');
    }
  }

  deleteOwner(registrationOwner, index) {
    // If the row being deleted is the auto-added formEntryOwner, clear the reference
    // so ContactOwnerChanged() can re-add it if "Owner" is re-selected
    if (registrationOwner === this.formEntryOwner) {
      this.formEntryOwner = null;
    }
    // Resolve index from ownersList if only the object was passed (defensive)
    const resolvedIndex = (index !== undefined && index !== null) ? index
      : this.ownersList.indexOf(registrationOwner);
    if (resolvedIndex !== -1) {
      this.pr.registrationOwners.splice(resolvedIndex, 1);
      this.ownersList.splice(resolvedIndex, 1);
    }
  }

  onPbsApprovalDateChange(date: NgbDateStruct): void {
    this.pbsApprovalDatePickerModel = date;
    this.pr.pbsApprovalDate = this.toDate(date);
  }

  private twoDigits(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  private toDate(date: NgbDateStruct): Date | null {
    if (!date || !date.year || !date.month || !date.day) {
      return null;
    }

    return new Date(date.year, date.month - 1, date.day);
  }

  private parseIsoDate(value: any): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return {
        year: value.getFullYear(),
        month: value.getMonth() + 1,
        day: value.getDate()
      };
    }

    if (typeof value === 'string') {
      const parts = value.split('-');
      if (parts.length !== 3) {
        return null;
      }

      const year = Number(parts[0]);
      const month = Number(parts[1]);
      const day = Number(parts[2]);
      if (!year || !month || !day) {
        return null;
      }

      return { year, month, day };
    }

    return null;
  }
}